const TokenKey = 'b2b_token';
const potTokenKey = 'b2b_potTokenKey';

export function getToken() {
  return window.sessionStorage.getItem(TokenKey);
}

export function setToken(token) {
  return window.sessionStorage.setItem(TokenKey, token);
}

export function getPotToken() {
  return window.sessionStorage.getItem(potTokenKey);
}

export function setPotToken(token) {
  return window.sessionStorage.setItem(potTokenKey, token);
}

export function removeToken() {
  return window.sessionStorage.removeItem(TokenKey);
}



// WEBPACK FOOTER //
// ./src/utils/auth.js